exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.admin-projects .stat-card[data-v-0c9e8fb4]{cursor:pointer;transition:transform .15s ease,box-shadow .15s ease\n}\n.admin-projects .stat-card[data-v-0c9e8fb4]:hover{transform:translateY(-2px);box-shadow:0 4px 12px rgba(0,0,0,.12) !important\n}\n.admin-projects .stat-value[data-v-0c9e8fb4]{font-size:1.5rem;font-weight:700;color:#1976d2\n}\n.admin-projects .stat-label[data-v-0c9e8fb4]{font-size:.75rem;text-transform:uppercase;letter-spacing:.5px\n}\n.admin-projects .scroll-boundary[data-v-0c9e8fb4]{height:1px\n}", ""]);

// exports
